import { MenuItem } from './dateMenus'

export type CancellationReq = {
  cancelledObjectType: CancelledObjectType
  cancelledObjectId: string
}

export type ApiCancellationPreviewResp = {
  orderImpacts: {
    totalImpactedOrders: number
    totalCancelledOrders: number
    totalPartialUpdateOrders: number
    totalItemsDeleted: number
  }
  financialImpacts: {
    totalEmployeeRefunds: string
    totalSubsidyAdjustment: string
    chefPayoutAdjustment: string
    netRevenueImpact: string
  }
  subOrderIds: string[]
}

export type CancellationPreviewResp = {
  orderImpacts: {
    totalImpactedOrders: number
    totalCancelledOrders: number
    totalPartialUpdateOrders: number
    totalItemsDeleted: number
  }
  financialImpacts: {
    totalEmployeeRefunds: number
    totalSubsidyAdjustment: number
    chefPayoutAdjustment: number
    netRevenueImpact: number
  }
  subOrderIds: string[]
}

export type CancellationResp = {
  subOrderCancelledMap: Record<string, UserCancellationResp>
  groupOrderUpdatedError: string | null
  accountingUpdatedError: string | null
}

export type UserCancellationResp = {
  orderNumber: string
  userEmail: string
  refundNeeded: boolean
  refundError: string | null
  subOrderUpdatedError: string | null
  emailSentError: string | null
}

export enum CancellationScope {
  GROUP_ORDER = 'group_order',
  VENDOR = 'vendor',
  MENU = 'menu',
  ITEM = 'item',
}

export enum CancelledObjectType {
  ITEM = 'item',
  MENU = 'menu',
  VENDOR = 'vendor',
}

export enum CancellationType {
  PRE_CUTOFF_VENDOR = 'vendor',
  POST_CUTOFF_DISSATISFACTION = 'customer',
  PRE_CUTOFF_CLIENT = 'client',
}

export enum CancellationReason {
  VENDOR_SUPPLY = 'vendor_supply',
  VENDOR_STAFFING = 'vendor_staffing',
  VENDOR_LOW_VOLUME = 'vendor_low_volume',
  VENDOR_OTHER = 'vendor_other',
  CUSTOMER_QUALITY_ISSUE = 'customer_quality_issue',
  CUSTOMER_INCORRECT_ITEM = 'customer_incorrect_item',
  CUSTOMER_OTHER = 'customer_other',
  // TODO: maybe not needed?
  CLIENT_OFFICE_CLOSURE = 'office_closure',
  CLIENT_EVENT_CANCELED = 'event_canceled',
  CLIENT_LOCATION_CHANGE = 'location_change',
  CLIENT_OTHER = 'other',
}

export type CancelGroupOrderObjectReq = {
  grpId: string
  cancelledObjectId: string
  cancelledObjectType: CancelledObjectType
  cancellationScope: CancellationScope
  cancellationType: CancellationType
  cancellationReason: CancellationReason
  chefPayoutAdjustment: number | undefined
  subOrderIds: string[]
  sendChefCancellationEmail: boolean
  triggerSource: CancelTriggerSource
}

export enum CancelTriggerSource {
  ADMIN = 'admin',
  CLOUD_KITCHENS = 'cloud_kitchens',
}

export enum SubOrderCancellationAction {
  CANCEL = 'cancel',
  PARTIAL_UPDATE = 'partial_update',
}

export type GetCancelledSubOrdersReq = {
  subOrderIds: string[]
  cancelledObjectId: string
  cancelledObjectType: CancelledObjectType
}

export type VendorMenuGroup = {
  vendorId: string
  vendorName: string
  menuCount: number
  totalOrderCount: number
  menus: {
    id: string
    menuName: string
    orderCount: number
    cutoffTime: string
    entrees: MenuItem[]
    sides: MenuItem[]
    drinks: MenuItem[]
    desserts: MenuItem[]
    active: boolean
    lastActive: string | undefined
    budgetPerPerson: number
    isOverBudget: boolean
    cutoffEmailSentAt: string | null
    cancellationEventId: string | null
  }[]
  cancelled: boolean
}

export type CustomerCancelledSubOrdersResp = {
  id: string
  customerName: string
  customerEmail: string
  updatedOrders: CancellationSubOrder[]
  sameGroupOrderUpdatedOrders: CancellationSecondarySubOrder[]
  externalWalletUpdatedOrders: CancellationSecondarySubOrder[]
}

export type CancellationSubOrder = {
  id: string
  orderNumber: string
  orderDate: string
  deliveryTime: string
  action: SubOrderCancellationAction
  orderDetails: CancellationOrderDetails
}

export type CancellationOrderDetails = {
  totalItems: number
  remainingItems: CancellationOrderItem[]
  removedItems: CancellationOrderItem[]
  originalSubsidyAmount: string
  originalEmployeeAmount: string
  newSubsidyAmount: string
  newEmployeeAmount: string
  refundOwedToCustomer: string
}

export type CancellationOrderItem = {
  id: string
  itemName: string
  vendorName: string
  quantity: number
}

export type CancellationSecondarySubOrder = {
  id: string
  orderNumber: string
  orderDate: string
  deliveryTime: string
  subsidyAmount: string
  employeeAmount: string
  newSubsidyAmount: string
  newEmployeeAmount: string
  employeeRefundAmount: string
}

export type CancellationReasonObj = {
  label: string
  value: CancellationReason
  cancellationType: CancellationType
}

export type CancelledObject = {
  grpId: string
  id: string
  name: string
  type: CancelledObjectType
  scope: CancellationScope
  from?: string
}
